import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IFilterOption } from '@rankmi/rankmi-table/dist/interfaces/filterProps'

import { joinKeys } from 'helpers/translations.helper'
import { IMainState } from 'store/states'
import { prefixTranslation } from '../common'
import { ExternalCourseModelAPI } from 'models/externalCourse.model'
import { CourseModality, getTranslationKey } from 'enum/courseModalities.enum'

interface Column extends IFilterOption {
  label: string
  type: string
  value: keyof ExternalCourseModelAPI
}

export const useFiltersColumns = () => {
  const prefix = joinKeys(prefixTranslation, 'attributes')
  const prefixFilters = joinKeys(prefixTranslation, 'modalities')

  const [filtersColumns, setFilterColumns] = useState<Column[]>([])
  const { t } = useTranslation()
  const { loading: profilesLoading } = useSelector(
    ({ lmsProfiles }: IMainState) => lmsProfiles
  )
  useEffect(() => {
    if (!profilesLoading) {
      setFilterColumns([
        {
          label: t(`${prefix}.name`),
          value: 'name',
          type: 'string',
        },
        {
          label: t(`${prefix}.modality`),
          value: 'modality',
          type: 'tagsList',
          list: [
            CourseModality.blended,
            CourseModality.faceToFace,
            CourseModality.online,
          ].map((value) => {
            const key = getTranslationKey(value)
            return {
              value,
              label: t(`${prefixFilters}.${key}`),
            }
          }),
        },
        {
          label: t(`${prefix}.startDate`),
          value: 'startDate',
          type: 'date',
        },
        {
          label: t(`${prefix}.endDate`),
          value: 'endDate',
          type: 'date',
        },
        {
          label: t(`${prefix}.createAt`),
          value: 'createdAt',
          type: 'date',
        },
      ])
    }
  }, [prefix, prefixFilters, profilesLoading, t])
  return filtersColumns
}
